import React from 'react'
import * as helpers from '../Base/Helpers'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class TagValue extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    tag: PropTypes.any,
    itemToString: PropTypes.func,
    onRemove: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      // editing: false,
      value: props.tag.value
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.tag !== this.props.tag) {
      this.setState({ value: nextProps.tag.value })
    }
  }

  onRemove = e => {
    const { onRemove, tag, disabled } = this.props
    e.preventDefault()
    e.stopPropagation()

    if (disabled) return

    if (onRemove) {
      onRemove({ ...tag, value: this.state.value })
    }
  }

  inputRef = c => {
    this._input = c
  }

  render() {
    const { itemToString, tag, disabled } = this.props
    const tagText = helpers.renderItem({ itemToString, item: tag })

    const tagRemoveButtonClasses = classNames({
      'autocomplete__tag-remove': true,
      'autocomplete__tag-remove--disabled': disabled
    })

    return (
      <div className={`autocomplete__tag${tag.invalid ? ' invalid' : ''}`}>
        {tagText}{' '}
        <button className={tagRemoveButtonClasses} onClick={this.onRemove}>
          ✕
        </button>
      </div>
    )
  }
}

export default TagValue
